// ADR-132: ingestion configuration constants. Mirrors radar-api
// src/utils/ingestionMappingTypes.js (Prisma enums IngestionProviderEnum /
// IngestionMappingOutcomeEnum / IngestionMappingHistoryActionEnum).

export const INGESTION_PROVIDERS = Object.freeze({
  AMERICAS: 'AMERICAS',
  POWERBI: 'POWERBI',
});

export const INGESTION_PROVIDER_OPTIONS = [
  {
    value: INGESTION_PROVIDERS.AMERICAS,
    label: 'Americas',
    slug: 'americas',
    sourceLabel: 'Americas feed job title',
    syncHint: 'Americas employee sync (weekdays, 07:00)',
  },
  {
    value: INGESTION_PROVIDERS.POWERBI,
    label: 'PowerBI',
    slug: 'powerbi',
    sourceLabel: 'Enova job title (grade removed)',
    syncHint: 'PowerBI (Enova) employee sync (weekdays, 02:00 and 06:00)',
  },
];

export const INGESTION_MAPPING_OUTCOMES = Object.freeze({
  MAP_TO_POSITION: 'MAP_TO_POSITION',
  NO_POSITION: 'NO_POSITION',
});

export const INGESTION_MAPPING_OUTCOME_LABELS = {
  [INGESTION_MAPPING_OUTCOMES.MAP_TO_POSITION]: 'Maps to position',
  [INGESTION_MAPPING_OUTCOMES.NO_POSITION]: 'No position',
};

export const INGESTION_PATTERN_MATCH_TYPES = Object.freeze({
  EXACT: 'EXACT',
  PATTERN: 'PATTERN',
  CATCH_ALL: 'CATCH_ALL',
});

// Match chip colours (Match filter + table rows): pastel background / darker text.
export const INGESTION_PATTERN_MATCH_TYPE_COLORS = {
  EXACT: { bg: '#E6F4EA', color: '#1E8E3E' },
  PATTERN: { bg: '#EDE9FE', color: '#6D28D9' },
  CATCH_ALL: { bg: '#FEF3C7', color: '#92400E' },
};

export const INGESTION_PATTERN_MATCH_TYPE_LABELS = {
  [INGESTION_PATTERN_MATCH_TYPES.EXACT]: 'Exact',
  [INGESTION_PATTERN_MATCH_TYPES.PATTERN]: 'Pattern',
  [INGESTION_PATTERN_MATCH_TYPES.CATCH_ALL]: 'Catch-all',
};

export const INGESTION_MAPPING_HISTORY_ACTION_LABELS = {
  CREATE: 'Added',
  UPDATE: 'Changed',
  DELETE: 'Removed',
  IMPORT_CREATE: 'Added (import)',
  IMPORT_UPDATE: 'Changed (import)',
  IMPORT_DELETE: 'Removed (import)',
};

export const INGESTION_IMPORT_MODES = Object.freeze({
  MERGE: 'merge',
  REPLACE: 'replace',
});

export const INGESTION_SOURCE_PATTERN_MAX_LENGTH = 500;

export const JOB_POSITION_MAPPINGS_PATH = '/ingestion/job-position-mappings';

/** Route slug ("americas") → provider option, or null. */
export const findProviderBySlug = (slug) => INGESTION_PROVIDER_OPTIONS
  .find((option) => option.slug === String(slug || '').toLowerCase()) || null;
